import { supabase } from '../lib/supabase'

export const getFileUrl = async (filePath: string | null, bookCode: string | null): Promise<string | null> => {
    if (!filePath) return null

    // Construct the full path: {book.code}/{question.file}
    const fullPath = bookCode ? `${bookCode}/${filePath}` : filePath

    try {
        const { data, error } = await supabase.storage
            .from('files')
            .createSignedUrl(fullPath, 3600) // URL valid for 1 hour

        if (error) throw error
        return data.signedUrl
    } catch (err) {
        // If the object is not found, just return null (common for missing PDFs)
        if (err && typeof err === 'object' && 'message' in err && (err as any).message.includes('Object not found')) {
            console.warn(`File not found: ${fullPath}`)
            return null
        }
        console.error('Failed to get file URL:', err)
        return null
    }
}
